window.addEventListener('load', function() {
    // GSAPとScrollTriggerが利用可能かチェック
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.error('GSAPまたはScrollTriggerが読み込まれていません。');
      return;
    }
  
    // ScrollTriggerプラグインを登録
    gsap.registerPlugin(ScrollTrigger);
  
    // アニメーション対象の要素を取得
    const fadeInItems = document.querySelectorAll('.animated__fadeIn, .fadeIn');
    const timeDelay = 250; // 遅延時間（ミリ秒）
    const maxItemNumber = 6; // 遅延アニメーションの最大数
  
    // 画面の高さを取得
    const windowHeight = window.innerHeight;
  
    // 遅延なしのフェードインアニメーション
    fadeInItems.forEach(item => {
      ScrollTrigger.create({
        trigger: item,
        start: () => window.innerWidth <= 750 ? `top ${windowHeight * 0.85}px` : `top ${windowHeight * 0.7}px`,
        onEnter: () => {
          item.classList.add("js-show");
        },
      });
    });
  
    // 遅延付きのフェードインアニメーション
    for (let i = 0; i < maxItemNumber; i++) {
      const delayedFadeInItems = document.querySelectorAll(`.animated__fadeIn.--delay${i}`);
      fadeInFunction(delayedFadeInItems, i * timeDelay);
    }
  
    // 遅延付きフェードイン関数
    function fadeInFunction(fadeInItems, timeout) {
      fadeInItems.forEach(item => {
        ScrollTrigger.create({
          trigger: item,
          start: () => window.innerWidth <= 750 ? `top ${windowHeight * 0.85}px` : `top ${windowHeight * 0.7}px`,
          onEnter: () => {
            setTimeout(() => {
              item.classList.add("js-show");
            }, timeout);
          }
        });
      });
    }
  });